var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":_vm.show,"variant":"danger"}},[_c('h5',[_vm._v("Unknown Filter")]),_c('pre',{staticClass:"text-inherit"},[_vm._v(_vm._s(_vm.properties))]),_c('input',{staticClass:"form-control",attrs:{"type":"hidden"}})])}
var staticRenderFns = []

export { render, staticRenderFns }